import { StyleDeclarationValue, css } from 'aphrodite';
import * as React from 'react';
import { NavLink } from 'react-router-dom';
import { HatIcon } from '../svgs/icons/HatIcon';
import { styleSheet } from './styles';

interface IProps {
	className?: string;
	styles?: StyleDeclarationValue[];
}

export const TaggingGameLink: React.FC<IProps> = () => {
	return (
		<NavLink className={css(styleSheet.taggingGameLink)} target='_blank' to='/people/tagging-game'>
			Tagging Game
			<HatIcon />
		</NavLink>
	);
};
